import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, FESTIVAL_META } from "@/lib/api";
import { Flame, Play, Music } from "lucide-react";

function AnnouncementCard({ a }) {
  const meta = FESTIVAL_META[a.festival_id];
  const artist = a.artist;
  const [open, setOpen] = useState(false);
  return (
    <article className="card-flat overflow-hidden" style={{ borderLeft: `3px solid ${meta?.color}` }} data-testid={`ann-${a.announcement_id}`}>
      <div className="p-6 flex gap-5">
        {artist?.image_url ? (
          <img src={artist.image_url} alt="" className="w-24 h-24 rounded-lg object-cover flex-shrink-0" />
        ) : (
          <div className="w-24 h-24 rounded-lg bg-zinc-800 flex items-center justify-center flex-shrink-0"><Music size={24} className="text-zinc-600" /></div>
        )}
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 text-xs">
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-orange-500/10 text-orange-400"><Flame size={12}/> NY ANNONCERING</span>
            <span className="text-zinc-500">{new Date(a.created_at).toLocaleString("da-DK")}</span>
          </div>
          <h2 className="font-display font-bold text-3xl mt-3 truncate">{a.artist_name}</h2>
          <div className="mt-1 text-zinc-400 text-sm">
            {meta?.name} · <span className="capitalize">{a.category}</span>
            {a.is_headliner && <span className="ml-2 px-2 py-0.5 rounded-full bg-white/10 text-white text-xs font-semibold">HEADLINER</span>}
            {a.is_orange_opener && <span className="ml-2 px-2 py-0.5 rounded-full bg-orange-500 text-black text-xs font-semibold">ORANGE ÅBNER</span>}
          </div>
          {artist?.genres?.length > 0 && (
            <div className="mt-2 text-xs text-zinc-500 truncate">{artist.genres.slice(0, 4).join(" · ")}</div>
          )}
        </div>
        {artist?.spotify_id && (
          <button onClick={() => setOpen(v => !v)} className={`self-start p-2 rounded-full ${open ? "bg-emerald-500/20 text-emerald-400" : "bg-white/5 text-zinc-400"} hover:bg-emerald-500/10`} data-testid={`ann-play-${a.announcement_id}`} aria-label="Preview">
            <Play size={16} />
          </button>
        )}
      </div>
      {open && artist?.spotify_id && (
        <iframe src={`https://open.spotify.com/embed/artist/${artist.spotify_id}?theme=0`} width="100%" height="152" frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title={artist.name} className="border-t border-white/5" data-testid={`ann-iframe-${a.announcement_id}`} />
      )}
      <div className="px-6 pb-5 border-t border-white/5 pt-4">
        <div className="text-sm text-zinc-500">{a.predictor_count} spiller{a.predictor_count === 1 ? "" : "e"} forudsagde dette</div>
        {a.reactions?.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-2">
            {a.reactions.map((r, i) => (
              <span key={i} className={`text-xs px-2 py-1 rounded-full ${r.points > 0 ? "bg-emerald-500/10 text-emerald-300" : "bg-red-500/10 text-red-300"}`}>
                {r.display_name} {r.points > 0 ? `+${r.points}` : "missed"}
              </span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}

export default function Announcements() {
  const { data: items } = useQuery({ queryKey: ["announcements"], queryFn: () => api.get("/announcements").then(r => r.data) });

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="label-eyebrow">Live feed</div>
      <h1 className="hero-title text-4xl sm:text-5xl mt-2">Nyeste annonceringer</h1>

      <div className="mt-10 space-y-4">
        {items?.map(a => <AnnouncementCard key={a.announcement_id} a={a} />)}
        {(!items || items.length === 0) && <div className="card-flat p-10 text-center text-zinc-500">Ingen annonceringer endnu. Kom tilbage snart!</div>}
      </div>
    </div>
  );
}
